export const toPascalCase = (str) => {
    return str
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Split camel case
        .replace(/[^a-zA-Z0-9 ]/g, ' ') // Remove special characters
        .replace(/\s+(.)/g, (_, chr) => chr.toUpperCase()) // Convert first letter after spaces to uppercase
        .replace(/\s/g, '') // Remove spaces
        .replace(/^(.)/, (_, chr) => chr.toUpperCase()); // Convert first letter to uppercase
};

//Adicionar um espaço antes de cada letra maiúscula, exceto a primeira letra
export function giveSpaceBetweenCapitalLetters(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
}

export const toPascalCaseWithSpace = async (str) => {
    const pascalCase = toPascalCase(str);
    return await giveSpaceBetweenCapitalLetters(pascalCase);
}

export const toSnakeCase = (str) => {
    return str
        .replace(/([a-z])([A-Z])/g, '$1_$2') // Split camel case
        .replace(/\s/g, '_') // Convert spaces to underscores
        .toLowerCase();
};

export const toKebabCase = (str) => {
    return str
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/\s+/g, '-')
        .replace(/_/g, '-')
        .toLowerCase();
}